import type { BudgetSummary } from '@/types';

export function filterRootBudgets<T extends { parentId?: string | null }>(budgets: T[]): T[] {
  return budgets.filter((budget) => !budget.parentId);
}

/**
 * Split budgets into the user's own budgets and budgets shared with them.
 * Budgets without ownership info (older API responses) count as owned.
 */
export function partitionByOwnership<T extends { owned?: boolean }>(
  budgets: T[]
): { owned: T[]; sharedWithMe: T[] } {
  return {
    owned: budgets.filter((budget) => budget.owned !== false),
    sharedWithMe: budgets.filter((budget) => budget.owned === false),
  };
}

export function filterPastRootBudgets(
  allBudgets: BudgetSummary[],
  activeRootIds: Set<string>
): BudgetSummary[] {
  return filterRootBudgets(allBudgets)
    .filter((budget) => {
      if (activeRootIds.has(budget.id)) return false;
      const remaining = budget.remaining ?? (budget.amount - (budget.spent ?? 0));
      return remaining > 5;
    })
    .sort((a, b) => b.endDate.localeCompare(a.endDate));
}

/** @deprecated Use filterPastRootBudgets */
export const filterNonEndedRootBudgets = filterPastRootBudgets;
